module.exports = __webpack_public_path__ + "image-06b385366d01.png";